import { DataBindingEventArgs as DataBindingEventArgs_internal } from "./DataBindingEventArgs";
import { IgrDateTimeCellInfo } from "./igr-date-time-cell-info";
import { IgrImageCellInfo } from "./igr-image-cell-info";
import { IgrNumericCellInfo } from "./igr-numeric-cell-info";
import { IgrRowSeparatorInfo } from "./igr-row-separator-info";
import { IgrSectionHeaderCellInfo } from "./igr-section-header-cell-info";
import { IgrTemplateCellInfo } from "./igr-template-cell-info";
import { IgrTemplateHeaderCellInfo } from "./igr-template-header-cell-info";
import { IgrTemplateSectionHeaderCellInfo } from "./igr-template-section-header-cell-info";
import { IgrTextCellInfo } from "./igr-text-cell-info";
import { IgrTextHeaderCellInfo } from "./igr-text-header-cell-info";
/**
 * Information about the data binding taking place.
*/
var IgrDataBindingEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrDataBindingEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrDataBindingEventArgs.prototype.createImplementation = function () {
        return new DataBindingEventArgs_internal();
    };
    Object.defineProperty(IgrDataBindingEventArgs.prototype, "i", {
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrDataBindingEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrDataBindingEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrDataBindingEventArgs.prototype, "cellInfo", {
        /**
         * The backing information for the current cell.
        */
        get: function () {
            if (this.i.cellInfo == null) {
                return null;
            }
            if (!this.i.cellInfo.externalObject) {
                var ext = null;
                switch (this.i.cellInfo.$type.name) {
                    case "DateTimeCellModel":
                        ext = new IgrDateTimeCellInfo();
                        break;
                    case "ImageCellModel":
                        ext = new IgrImageCellInfo();
                        break;
                    case "NumericCellModel":
                        ext = new IgrNumericCellInfo();
                        break;
                    case "RowSeparatorModel":
                        ext = new IgrRowSeparatorInfo();
                        break;
                    case "SectionHeaderCellModel":
                        ext = new IgrSectionHeaderCellInfo();
                        break;
                    case "TemplateCellModel":
                        ext = new IgrTemplateCellInfo();
                        break;
                    case "TemplateHeaderCellModel":
                        ext = new IgrTemplateHeaderCellInfo();
                        break;
                    case "TemplateSectionHeaderCellModel":
                        ext = new IgrTemplateSectionHeaderCellInfo();
                        break;
                    case "TextCellModel":
                        ext = new IgrTextCellInfo();
                        break;
                    case "TextHeaderCellModel":
                        ext = new IgrTextHeaderCellInfo();
                        break;
                }
                ext._implementation = this.i.cellInfo;
                this.i.cellInfo.externalObject = ext;
            }
            return this.i.cellInfo.externalObject;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDataBindingEventArgs.prototype, "resolvedValue", {
        /**
     * The resolved value for the cell.
    */
        get: function () {
            return this.i.resolvedValue;
        },
        set: function (v) {
            this.i.resolvedValue = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrDataBindingEventArgs.prototype, "rowObject", {
        /**
         * The data for the row in which the cell is contained.
        */
        get: function () {
            return this.i.rowObject;
        },
        set: function (v) {
            this.i.rowObject = v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrDataBindingEventArgs;
}());
export { IgrDataBindingEventArgs };
//# sourceMappingURL=igr-data-binding-event-args.js.map
